
import React from "react";
import { NursingHomeCard } from "@/components/nursing-homes/NursingHomeCard";
import { LoadingState } from "@/components/nursing-homes/LoadingState";
import { EmptyState } from "@/components/nursing-homes/EmptyState";
import { ErrorState } from "@/components/nursing-homes/ErrorState";

interface NursingHomeResultsProps {
  isLoading: boolean;
  error: Error | null;
  nursingHomes: any[];
  countyName: string;
  countySlug: string;
  searchQuery: string;
}

export function NursingHomeResults({
  isLoading,
  error,
  nursingHomes,
  countyName,
  countySlug,
  searchQuery
}: NursingHomeResultsProps) {
  if (isLoading) return <LoadingState />;
  if (error) return <ErrorState countyName={countyName} error={error} />;
  if (!nursingHomes || nursingHomes.length === 0) return <EmptyState countyName={countyName} />;

  console.log('Nursing homes to render:', nursingHomes);

  return (
    <>
      <div className="mb-6">
        <p className="text-sm text-grandpal-gray">
          Found {nursingHomes.length} nursing homes
          {searchQuery && ` matching "${searchQuery}"`}
          {countyName && ` in ${countyName}`}
        </p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {nursingHomes.map((home) => (
          <NursingHomeCard 
            key={home.nh_slug}
            nursingHome={home}
            hideBorder={false}
            size="md"
          />
        ))}
      </div>
    </>
  );
}
